export var max = Math.max;
export var min = Math.min;
export var round = Math.round;


//////////////////
// WEBPACK FOOTER
// /Users/benchmark/Sites/thomsonbiketours/wp-content/themes/thomson/node_modules/@popperjs/core/lib/utils/math.js
// module id = 12
// module chunks = 0